import {
	SET_COLLATERAL,
	UPDATE_COLLATERAL,
	ADD_COLLATERAL,
	BACK_COLLATERAL
} from '../config/actionTypes';

const initialState = {
	id: 0,
	no: 0,
	name: '',
	url: '',
	amount: 0,
	active: false,
	is_trial: false,
	is_paid: false,
	is_collateralized: false,
	is_public: false,
	is_featured: false,
	pledges: {
		total: 0,
		mine: 0,
		count: 0
	},
	pledgesAll: {
		pledges: []
	}
};

const CollateralReducer = (state = initialState, action) => {
	const { data } = action;
	const newState = { ...state };
	switch (action.type) {
		case SET_COLLATERAL:
			return data;
		case UPDATE_COLLATERAL:
			const newData = { ...state, ...data };
			return newData;
		case ADD_COLLATERAL:
			newState.pledges.count =
				newState.pledges.mine === 0
					? newState.pledges.count + 1
					: newState.pledges.count;
			newState.pledges.total = state.pledges.total + data;
			newState.pledges.mine = state.pledges.mine + data;
			return newState;
		case BACK_COLLATERAL:
			newState.pledges.total = state.pledges.total - data;
			newState.pledges.mine = state.pledges.mine - data;
			newState.pledges.count = state.pledges.count - 1;
			return newState;
		default:
			return state;
	}
};

export default CollateralReducer;
